import { gql } from '@apollo/client';

export const HasAccessForPlatformQuery = gql`
    query HasAccessForPlatform {
        hasAccessForPlatform
    }
`;
